var exports = {
  "VH": "FeedLinkPreview.module__preview___dmp5OU",
  "Nr": "FeedLinkPreview.module__card___dmp5OU",
  "Mn": "FeedLinkPreview.module__provider___dmp5OU",
  "h_": "FeedLinkPreview.module__description___dmp5OU",
  "Sl": "FeedLinkPreview.module__image___dmp5OU",
  "Qq": "FeedLinkPreview.module__text___dmp5OU",
  "DD": "FeedLinkPreview.module__title___dmp5OU",
};

module.exports = exports;
